import { useTraderLanguage } from '../context/TraderLanguageContext';
import { useTraderTheme } from '../context/TraderThemeContext';

export const TraderLanguageSelect = ({ id = 'trader-settings-language' }) => {
  const { language, setLanguage, tx } = useTraderLanguage();
  const { isDark } = useTraderTheme();
  return <select id={id} data-testid={id} aria-label={tx('Language')} value={language} onChange={event => setLanguage(event.target.value)} className={`min-w-0 max-w-full rounded border px-2 py-1 text-sm ${isDark ? 'bg-gray-900 border-gray-600 text-white' : 'bg-white border-gray-300 text-gray-900'}`}>
    <option value="en">English</option><option value="tr">Türkçe</option>
  </select>;
};